import { render, staticRenderFns } from "./changeCompany.vue?vue&type=template&id=49aff24f&"
import script from "./changeCompany.vue?vue&type=script&lang=js&"
export * from "./changeCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49aff24f')) {
      api.createRecord('49aff24f', component.options)
    } else {
      api.reload('49aff24f', component.options)
    }
    module.hot.accept("./changeCompany.vue?vue&type=template&id=49aff24f&", function () {
      api.rerender('49aff24f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/changeCompany.vue"
export default component.exports